import React, { Component } from 'react';
import {
    Modal, Button
} from 'react-bootstrap';
import axios from 'axios';
import Common from '../../Common'
import { window, document } from 'browser-monads'

class SLogin extends Component {
    constructor(props) {
        super(props);

        this.setToken = props.setTokenHandler

        this.state = {
            isModalOpen: false,
            password: ''
        };
    }

    handleEmperor = () => {
        if(Common.checkQueryParam(Common.EMPEROR_MODE)) {
            this.setState({isModalOpen: true})
        }
    }

    handleSubmit = () => {
        const httpClient = axios.create();
        httpClient.defaults.timeout = 2000;

        httpClient.get(Common.getEndpoint() + "/emperor-auth/?password=" + this.state.password)
        .then((response) => {
            let isSuccess = response.data.success

            if(isSuccess === "true") {
                let token = response.data.token
                console.log("Emperor validated... Turning on emperor mode...")
                this.setToken(token)
                this.setState({isModalOpen: false})
            } else {
                window.alert('Incorrect password')
                window.location.href = "/"
            }
        }).catch((error) => {
            window.location.href = "/"
        })
    }

    handleEnter = (e) => {
        if (e.key === 'Enter') {
            console.log('Enter pressed')
            this.handleSubmit()
        }
    }

    handleChange = (event) => {
        this.setState({password: event.target.value});
    }

    closeModal = () => {
        this.setState({
            isModalOpen: false
        });
        window.location.href = "/"
    }

    componentDidMount() {
        this.handleEmperor();
    }

    render() {
        return (
            <div>
                <Modal show={this.state.isModalOpen} onHide={this.closeModal} size="md">
                    <Modal.Body className="p-5 text-center">
                        <h3>Password</h3>
                        <input type="password" value={this.state.password} 
                            onChange={this.handleChange} onKeyPress={this.handleEnter}></input>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={this.handleSubmit}>Submit</Button>
                        <Button variant="secondary" onClick={this.closeModal}>Close</Button>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }
}

export default SLogin;